export default __webpack_public_path__ + "static/media/pic11.d7e7d908.jpg";